import { render, staticRenderFns } from "./FactoriesDrafts.vue?vue&type=template&id=1cec3a73"
import script from "./FactoriesDrafts.vue?vue&type=script&lang=js"
export * from "./FactoriesDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports